import { Tooltip } from '@/components/ui/tooltip'

import * as S from './field-row.styled'
import type { FieldCategoryRowProps } from './field-row.types'

// Note: compact "label | control" row used inside the multi-column category cards
export const FieldCategoryRow = ({
  children,
  depth,
  error,
  hint,
  label,
  message,
}: FieldCategoryRowProps) => (
  <S.CategoryRow $depth={depth}>
    <S.CategoryLabel>
      {!!depth && <S.CategoryBullet />}
      <S.CategoryText>
        {label}
        {(error || message) && (
          <S.CategoryMessage $error={!!error}>{error ?? message}</S.CategoryMessage>
        )}
      </S.CategoryText>
      {hint && <Tooltip>{hint}</Tooltip>}
    </S.CategoryLabel>
    <S.CategoryControl>{children}</S.CategoryControl>
  </S.CategoryRow>
)
